import { FormProvider } from 'react-hook-form'
import React from 'react'
import { Tab } from 'features/declaration/form/components/editorTabs'
import { UseTransitOperationFormReturn } from './useTransitOperationForm'

interface TransitOperationFormTabsProps {
  form: UseTransitOperationFormReturn
  activeTab: Tab
  generalTab: React.ReactNode
  transitPartisTab: React.ReactNode
}

function TransitOperationFormTabs({
  form,
  activeTab,
  generalTab,
  transitPartisTab,
}: TransitOperationFormTabsProps) {
  return (
    <FormProvider {...form}>
      <form id="transitOperation">
        <div hidden={activeTab !== 'general'}>{generalTab}</div>
        <div hidden={activeTab !== 'transit-parties'}>{transitPartisTab}</div>
      </form>
    </FormProvider>
  )
}

export default TransitOperationFormTabs
